import axios from "axios";
import { Listing, Service } from "../types";

export type SuccessfulSearchResult = {
  _status: {
    errors?: [];
  };
  data: {
    healthcareServices: Array<Service>;
  };
  count: number;
  offset: number;
  pageSize: number;
};

export type NoServicesFound = {
  _status: {
    errors: Array<{
      type: string;
      code: string;
      message: string;
      developerMessage: string;
    }>;
  };
};

export type Pagination = {
  count: number;
  offset: number;
  pageSize: number;
};

export type SearchResult = SuccessfulSearchResult | NoServicesFound;

type ParamKeys = "latitude" | "longitude" | "name" | "postcode" | "offset";
export type SearchParams = Partial<Record<ParamKeys, string>>;

const proximityParams = (lat: string, long: string) => {
  return {
    "location.proximity.near": `${lat},${long}`,
    "location.proximity.near_distance": "500000",
  };
};

const postcodeParams = (postcode: string) => {
  return {
    "location.proximity.near_postcode": postcode,
  };
};

const nameParams = (name: string) => {
  return {
    "search.name": name,
  };
};

export const constructParams = (params: SearchParams) => {
  let combinedParams = {};

  const { latitude, longitude, name, postcode, offset } = params;

  if (latitude && longitude) {
    combinedParams = {
      ...combinedParams,
      ...proximityParams(latitude, longitude),
    };
  }

  if (name) {
    combinedParams = { ...combinedParams, ...nameParams(name) };
  }

  if (postcode) {
    combinedParams = { ...combinedParams, ...postcodeParams(postcode) };
  }

  return combinedParams;
};

const nhsdDirectorySearch = async (
  params: SearchParams,
): Promise<[Array<Listing>, Pagination | null]> => {
  const [response, pagination] = await axios
    .get<SearchResult>("/nhsd/search", {
      params: params,
    })
    .then((response) => {
      console.log(response);
      if ("data" in response.data) {
        return [
          response.data.data.healthcareServices,
          {
            count: response.data.count, // Total number of results matching the search criteria
            offset: response.data.offset, // Page number (zero-indexed)
            pageSize: response.data.pageSize, // Page size
          },
        ];
      }

      // TODO: Handle failure to find healthcare services
      // response.data._status.errors
      return [[], null];
    })
    .catch((error) => {
      // Not currently showing error messages
      console.warn(error);
      return [[], null];
    });

  return [response as Array<Listing>, pagination as Pagination];
};

export {
  nhsdDirectorySearch as default,
  proximityParams,
  nameParams,
  postcodeParams,
};
